import { FC, useMemo } from "react";
import { CardBody, CardHeader } from "reactstrap";
import moment from "moment";
import StarRate from "../../../components/StarRate";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { fnRatingDisplay } from "../../../components/rateDisplay";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

const WidgetTemplate5: FC<IWidgetTemplate> = ({ company, score, review, theme }) => {
  const isDark = theme === "dark";
  const companyId = company?.companyId;

  const payload = useMemo(
    () => ({ companyId, widgetId: 5 as const }),
    [companyId],
  );

  const reviewsUrl = useMemo(
    () =>
      `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=banner&utm_campaign=list`,
    [companyId],
  );

  return (
    <div className="container">
      <div className="mt-4">
        <div>
          <CardHeader
            className={`p-2 rounded d-flex align-items-center flex-column ${
              isDark ? "bg-dark text-white" : "bg-white"
            }`}
          >
            <div className="d-flex">
              <h4 className="me-2">{fnRatingDisplay(score?.score)}</h4>
              <StarRateNewTrustScore value={score?.score} size={24} />
            </div>
            <div className="d-flex">
              <div className="my-2">
                based on{" "}
                <a
                  style={{ color: "unset" }}
                  href={reviewsUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  onClick={() => ReachClick(payload)}
                >
                  {score?.totalReview} reviews
                </a>
              </div>
              <div className="d-flex align-items-center ms-2">
                <img src={LOGO_MARK} alt="TrustFinance" width={24} height={24} />
                <span
                  style={{ fontSize: 14, marginLeft: 4, fontWeight: "bold" }}
                >
                  TrustFinance
                </span>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <p className={isDark ? "text-white" : ""}>
              Showing our latest reviews
            </p>
            {review?.data?.map((item) => (
              <div
                key={item.id}
                className={`p-3 my-2 rounded${isDark ? " text-white bg-dark" : ""}`}
              >
                <div>
                  <StarRate value={item.score} size={18} />
                  <h5 className="mt-2">{item.title}</h5>
                  <p className="fs-12 mb-2">{item.description}</p>
                  <div className="d-flex">
                    <span className="fs-12 fw-bold line-clamp-1 text-nowrap">
                      {item.user?.displayName}
                    </span>
                    <div
                      className={`fs-12 text-nowrap ${
                        isDark ? "text-secondary" : "text-black-50"
                      }`}
                    >
                      ,&nbsp;
                      {moment(item.createdAt).fromNow()}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </CardBody>
        </div>
      </div>
    </div>
  );
};

export default WidgetTemplate5;
